<template>
    <div class="client-item-modal">
        <section v-if="showSaveAsAnotherUserWarning" class="mt-8 mb-10 text-bold">
            <p>
                {{
                    $t('ui.warning_perform_action_as_oem', { oem: userStore.userData.owner_email })
                }}
            </p>
        </section>

        <section v-else>
            <ClientItemModalDetails v-if="tab < 1" />
            <ClientItemModalContactData v-else :saving="clientStore.saving" />
        </section>

        <div class="flex justify-start gap-2">
            <CoreLinkPrimary
                v-if="tab >= 1 && !showSaveAsAnotherUserWarning"
                text="§ui_button.back"
                class="client-item-modal__back-button"
                @click="back"
            />

            <CoreButton
                v-if="isContinueButtonShown"
                :disabled="!isDetailsPageValid"
                label="§ui_button.continue"
                @click="next"
                icon="pi-arrow-up-right"
            />

            <CoreButton
                v-else
                :disabled="isSaveButtonDisabled"
                label="§ui_button.save"
                icon="pi-save"
                :loading="clientStore.saving"
                @click="save"
            />

            <CoreButton
                variant="tertiary"
                :label="cancelButtonLabel"
                @click="handleClose"
                icon="pi-times"
            />
        </div>
    </div>
</template>

<script>
import { useCafStore } from '@/stores/caf'
import { useModalStore } from '@/stores/modal'
import { useClientStore } from '@/stores/client'
import { useUserStore } from '@/stores/user'
import ClientItemModalDetails from './components/ClientItemModalDetails.vue'
import ClientItemModalContactData from './components/ClientItemModalContactData.vue'
import CoreButton from '@/components/core/CoreButton.vue'
import CoreLinkPrimary from '@/components/core/CoreLinkPrimary.vue'

const FROM_CAF_MODAL = true

export default {
    name: 'ClientItemModal',

    components: {
        ClientItemModalDetails,
        ClientItemModalContactData,
        CoreButton,
        CoreLinkPrimary,
    },

    data() {
        return {
            cafStore: useCafStore(),
            modalStore: useModalStore(),
            clientStore: useClientStore(),
            userStore: useUserStore(),

            tab: 0,
            showSaveAsAnotherUserWarning: false,
            saving: false,
        }
    },

    computed: {
        isContinueButtonShown() {
            if (this.tab === 1) return false

            return true
        },

        isValidBasicInfo() {
            return this.clientStore.isValidBasicInfo
        },

        isValidAdditionalInfo() {
            return this.clientStore.isValidAdditionalInfo
        },

        isDetailsPageValid() {
            if (this.isValidBasicInfo && this.isValidAdditionalInfo) {
                return true
            }

            return false
        },

        isValidContactInfo() {
            return this.clientStore.isValidContactInfo
        },

        isSaveButtonDisabled() {
            if (this.clientStore.saving) {
                return true
            }

            if (this.isDetailsPageValid && this.isValidContactInfo) {
                return false
            }

            if (this.isDetailsPageValid) {
                return false
            }

            return true
        },

        cancelButtonLabel() {
            if (this.showSaveAsAnotherUserWarning) {
                return '§ui_button.cancel_change_oem'
            }

            return '§ui_button.cancel'
        },
    },

    created() {
        this.clientStore.resetState()
    },

    unmounted() {
        this.clientStore.resetState()
    },

    methods: {
        handleClose() {
            this.modalStore.setClose()
        },

        next() {
            this.tab = 1
        },

        back() {
            this.tab = 0
        },

        async save() {
            if (this.isActAsOemActive() && !this.showSaveAsAnotherUserWarning) {
                this.showSaveAsAnotherUserWarning = true
                return
            }
            await this.clientStore.create(FROM_CAF_MODAL)

            this.cafStore.sharedInputs.client_select = this.clientStore.clientData.id
            this.cafStore.sharedInputs.client_select_name = this.clientStore.clientData.name
            this.cafStore.sharedInputs.operator_country_id = this.clientStore.clientData.country_id

            this.handleClose()
        },
    },
}
</script>
